export default {
	id: "epitaph",
	pride: 8192,
	slug: "epitaph",
	category: "blog",
	status: "released",
	experienceable: true,
	titleKey: {
		zh: "墓志铭"
	},
	descriptionKey: {
		zh: "个人作品集网站。游戏、小说、VRChat、视频与更多创作的中枢展示。"
	},
	date: { year: 2026, month: 7 },
	genres: ["作品集", "个人网站"],
	themes: ["创作归档"],
	engine: "Web",
	platform: ["Web"],
	tags: ["作品集"],
	links: [
		{ type: "web", url: "https://e.tobenot.top/", textKey: { zh: "访问作品集" } }
	]
};
